import React from 'react'
import { connect as connectRedux } from 'react-redux'
import { Map, List } from 'immutable'
import _get from 'lodash/get'
import _set from 'lodash/set'
import { getBoundActions } from '../../../actions/index'
import { parse as parseQuery, stringify as stringifyQuery } from '../../../services/query-string/index'
import { CONTENT_IMAGE_TYPE_KEYART_WITH_TEXT } from '../../../services/content/index'
import Picture, { IMAGE_TYPE_WEBP, IMAGE_LOADING_LAZY } from '../../Picture/index'
import ProgressBar from '../../ProgressBar/index'

/**
 * DetailPageV3CourseFeaturedEpisode component renders an individual episode item with image
 * @param {Object} props - Component props
 * @param {Map} props.featuredContent - Immutable Map containing featured content data
 * @returns {JSX.Element} Rendered featured content component
 */
const DetailPageV3CourseFeaturedContent = (props) => {
  const {
    featuredContent = Map(),
  } = props

  const duration = featuredContent.getIn(['featureMedia', 'duration'], 0) || 0
  const userMediaPosition = featuredContent.getIn(['featureMedia', 'userMediaPosition', 'position'], 0) || 0
  const hasProgressBar = userMediaPosition > 0
  const image = featuredContent.get('images', List()).find((i) => i.get('type') === CONTENT_IMAGE_TYPE_KEYART_WITH_TEXT) || Map()

  const imageWidth = '385'
  let imageUrl = ''
  let fallbackImageUrl = ''

  try {
    const fallbackImageUrlObject = new URL(image.get('url'))
    const imageUrlObject = new URL(image.get('url'))
    const parsedFallbackImageQuery = parseQuery(_get(fallbackImageUrlObject, 'search', '')) || {}
    const parsedImageQuery = parseQuery(_get(imageUrlObject, 'search', '')) || {}
    const fallbackImageOptions = {
      ...parsedFallbackImageQuery,
      w: imageWidth,
      fm: 'jpg',
      compress: 'auto',
    }
    const imageOptions = {
      ...parsedImageQuery,
      w: imageWidth,
      fm: 'webp',
      q: '100',
    }

    const stringifiedFallbackQuery = stringifyQuery(fallbackImageOptions)
    const stringifiedImageQuery = stringifyQuery(imageOptions)

    _set(fallbackImageUrlObject, 'search', stringifiedFallbackQuery)
    _set(imageUrlObject, 'search', stringifiedImageQuery)

    fallbackImageUrl = fallbackImageUrlObject.toString()
    imageUrl = imageUrlObject.toString()
  } catch (e) {
    fallbackImageUrl = image
    imageUrl = image
  }

  return (
    <div className="detail-page-v3__course-featured-content">
      <Picture
        fallbackSrc={fallbackImageUrl}
        alt={featuredContent.get('title')}
        loading={IMAGE_LOADING_LAZY}
        sources={[
          {
            type: IMAGE_TYPE_WEBP,
            srcSet: imageUrl,
          },
        ]}
      />
      {hasProgressBar && (
        <div className="detail-page-v3__course-featured-content-progress-bar">
          <ProgressBar
            duration={duration}
            userInfo={Map({ featurePosition: userMediaPosition })}
          />
        </div>
      )}
    </div>
  )
}

export default connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3CourseFeaturedContent)
